/** Figma 89002:38624 — Goal Card V3 Activate 纹理背景（SaveGoal + Plan Banner 共用） */
export const GOAL_CARD_ACTIVATE_BG_SRC =
  "/assets/chat/save-goal-card/goal-card-bg.png";
